import React from 'react';
import Icon from '../../../components/AppIcon';

const AchievementCard = ({ title, description, progress, icon, iconColor, isCompleted, isPro, showNextMilestone, nextMilestone }) => {
  return (
    <div className={`
      bg-card rounded-lg p-20 md:p-24 lg:p-28 shadow-elevation-2 
      hover:shadow-elevation-3 transition-smooth
      ${isCompleted ? 'border-2 border-success' : ''}
    `}>
      <div className="flex items-start justify-between mb-16">
        <div className="flex items-center flex-1 min-w-0">
          <div 
            className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-lg flex-shrink-0 transition-smooth"
            style={{ backgroundColor: `${iconColor}15` }}
          >
            <Icon name={icon} size={24} color={iconColor} strokeWidth={2.5} />
          </div>
          <div className="ml-12 flex-1 min-w-0">
            <h4 className="text-base md:text-lg font-heading font-semibold text-card-foreground truncate">
              {title}
            </h4>
            <p className="text-sm text-muted-foreground mt-4 line-clamp-2">
              {description}
            </p>
          </div>
        </div>
        {isCompleted && (
          <Icon name="CheckCircle2" size={24} color="var(--color-success)" strokeWidth={2.5} className="ml-12 flex-shrink-0" />
        )}
      </div>

      <div className="mt-16">
        <div className="flex items-center justify-between mb-8">
          <span className="text-sm font-caption font-medium text-muted-foreground">
            Progress
          </span>
          <span className="text-sm font-caption font-semibold text-card-foreground">
            {Math.round(progress)}%
          </span>
        </div>
        <div className="w-full h-8 bg-muted rounded-full overflow-hidden">
          <div 
            className="h-full rounded-full transition-smooth"
            style={{ 
              width: `${progress}%`,
              backgroundColor: isCompleted ? 'var(--color-success)' : iconColor
            }}
          />
        </div>

        {/* Pro-only: Next milestone */}
        {isPro && showNextMilestone && nextMilestone && !isCompleted && (
          <div className="mt-12 pt-12 border-t border-border">
            <div className="flex items-start gap-8">
              <Icon name="Target" size={14} className="mt-2 flex-shrink-0 text-primary" />
              <div>
                <p className="text-xs text-muted-foreground mb-2">Next Milestone</p>
                <p className="text-sm font-medium text-foreground">{nextMilestone}</p>
              </div>
            </div>
          </div>
        )}

        {/* Completed message */}
        {isCompleted && isPro && (
          <div className="mt-12 pt-12 border-t border-border">
            <div className="flex items-center gap-8">
              <Icon name="Trophy" size={14} className="flex-shrink-0 text-success" />
              <p className="text-sm font-medium text-success">Achievement Unlocked!</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AchievementCard;